import { isNil } from 'ramda';
import { isFunction } from 'ramda-adjunct';
import { useCallback, useMemo } from 'react';
import { createLocalStorageUseState } from './createLocalStorageUseState';
const tryParseJson = (value, fallback) => {
    if (isNil(value)) {
        return fallback;
    }
    try {
        return JSON.parse(value);
    }
    catch (error) {
        return fallback;
    }
};
const getField = (field, record, fallback) => record[field] ?? fallback;
const setField = (field, value, record) => {
    const newRecord = { ...(record || {}) };
    if (isNil(value)) {
        delete newRecord[field];
    }
    else {
        newRecord[field] = value;
    }
    return newRecord;
};
export const createLocalStorageHashedStateHookWithTransformers = (key) => {
    const useProxy = createLocalStorageUseState(key);
    return (field, fallback) => {
        const [rawMap, setRawMap] = useProxy();
        const set = useCallback((valueOrUpdater) => setRawMap((oldRaw) => {
            const oldRecord = tryParseJson(oldRaw, {});
            const oldValue = getField(field, oldRecord, fallback);
            const newValue = isFunction(valueOrUpdater) ? valueOrUpdater(oldValue) : valueOrUpdater;
            const newRecord = setField(field, newValue, oldRecord);
            return JSON.stringify(newRecord);
        }), [fallback, field, setRawMap]);
        const value = useMemo(() => getField(field, tryParseJson(rawMap, {}), fallback), 
        // eslint-disable-next-line react-hooks/exhaustive-deps -- dont use fallback as dependency
        [field, rawMap]);
        return useMemo(() => [value, set], [set, value]);
    };
};
//# sourceMappingURL=createLocalStorageHashedStateHookWithTransformers.js.map